export enum APP_PATHS {
  home = '/menu',
}
